/**
 * Gatsby Browser API Configuration
 *
 * This file runs in the browser and handles:
 * - Global CSS/Tailwind styles
 * - Cookiebot consent event initialization
 * - Consent-aware scroll restoration
 */

import "./src/styles/global.css";
import { initConsentListeners, hasConsent } from "./src/shared/consent";
import type { GatsbyBrowser } from "gatsby";

/**
 * Called when the Gatsby app is first loaded in the browser
 */
export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  // Initialize Cookiebot consent event listeners
  // These allow components to react to consent changes (e.g., accessibility widget)
  initConsentListeners();
};

/**
 * Control scroll restoration behavior based on consent
 *
 * Gatsby uses sessionStorage (@@scroll|pathname) for scroll position.
 * This is categorized as "Preferences" by Cookiebot, so we only allow
 * scroll restoration when preferences consent is given.
 */
export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // Only restore scroll position if preferences consent is given
  if (hasConsent("preferences")) {
    const savedPosition = getSavedScrollPosition(location);
    if (savedPosition) {
      return savedPosition;
    }
  }

  // Default: scroll to top
  return [0, 0];
};
